(function(){
  function init(){
    var form=document.querySelector('.template-product .rx-pdp__form');
    if(!form||form.dataset.rxBar)return;
    form.dataset.rxBar='1';

    if(!form.querySelector('.rx-bar-price')){
      var box=document.querySelector('.rx-pdp__price');
      var p=document.createElement('span');
      p.className='rx-bar-price';
      if(box){
        var del=box.querySelector('del'),ins=box.querySelector('ins');
        if(del){var d=document.createElement('del');d.textContent=del.textContent.trim();p.appendChild(d)}
        var s=document.createElement('span');s.className='rx-bar-price__now';
        s.textContent=(ins?ins.textContent:box.textContent).trim();
        p.appendChild(s);
      }
      form.insertBefore(p,form.firstChild);
    }

    var spacer=document.createElement('div');
    spacer.className='rx-pdp__spacer';
    spacer.style.display='none';
    form.parentNode.insertBefore(spacer,form.nextSibling);

    function chk(){
      if(window.innerWidth>900){
        if(form.classList.contains('is-stuck')){form.classList.remove('is-stuck');spacer.style.display='none';document.body.style.paddingBottom=''}
        return;
      }
      var ref=form.classList.contains('is-stuck')?spacer:form;
      var off=ref.getBoundingClientRect().bottom<0;
      if(off!==form.classList.contains('is-stuck')){
        if(off){spacer.style.height=form.offsetHeight+'px';spacer.style.display='block'}
        form.classList.toggle('is-stuck',off);
        if(!off)spacer.style.display='none';
        document.body.style.paddingBottom=off?(form.offsetHeight+16)+'px':'';
      }
    }
    window.addEventListener('scroll',chk,{passive:true});
    window.addEventListener('resize',chk);
    chk();
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();